import React from 'react';
import { Avatar } from '@mui/joy';
import { Box } from '@mui/material';
import { Check } from '@mui/icons-material';
import { useThemeContext } from '../../../context/ThemeContext';

const Profile = 'assets/images/Mask group (11).png';
const Star = 'assets/images/icons/Star-8.png';


const FundProfileUser = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '146px',
        height: '146px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >

      <Avatar
        src={Profile}
        alt="User"
        sx={{
          width: '132.77px',
          height: '132.77px',
        }}
      />

   
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '146px',
          height: '146px',
          borderRadius: '50%',
          border: '2px solid #2E2E2E',
          boxSizing: 'border-box',
          pointerEvents: 'none',
        }}
      />

    
      <Box
        sx={{
          position: 'absolute',
          top: '20px',
          right: '-16px',
          backgroundImage: `url(${Star})`, 
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '50%',
          width: '35px',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'translate(-50%, -50%)',

        }}
      >

        <Check
          sx={{
            fontSize: '15px',

            width: "15px",
            height: "15px",
            color: '#FFFFFF',

          }}
        />
      </Box>

    </Box>
  );
};



export default FundProfileUser;